<template>
  <div class="c-project__image-component">
    <div class="u-show@large u-mts u-mbs">
      <section class="cropper-area">
        <div class="img-cropper">
          <vue-cropper
            ref="cropper"
            :auto-crop-area="1"
            :src="projectImageUrl"
            preview=".preview"
            class="c-card__picture"
            @ready="cropImage"
          />
        </div>
      </section>
      <section class="preview-area">
        <div class="cropped-image">
          <img
            v-if="croppedImgData"
            ref="croppedImageElement"
            :src="croppedImgData"
            alt="Cropped Image"
          >
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { getProject } from '@/utils/api'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

const props = defineProps<{
  projectId: number
  projectImageUrl: string
}>()

const project = ref(await getProject(props.projectId))

const croppedImageElement = ref<HTMLImageElement>()

const isLoading = ref(true)

// Banner image
const cropper = ref()
const cropData = ref('')
const croppedImgData = ref('')
const isCropped = ref(false)

function setCropData () {
  if (project.value.banner_crop_data && !project.value.banner_crop_data.includes('object')) {
    cropData.value = JSON.parse(project.value.banner_crop_data)
    if (!cropData.value) return

    cropper.value.setData(cropData.value)
  }
}

async function cropImage () {
  if (!isCropped.value) {
    setCropData()

    croppedImgData.value = cropper.value.getCroppedCanvas().toDataURL()

    if (cropper.value && croppedImgData.value) {
      cropper.value.replace(croppedImgData.value)
      isCropped.value = true
      isLoading.value = false
    }
  }
}
</script>

<style scoped lang="scss">
.cropper-area {
  display: none;
}
</style>
